import { type FallFoliageStyle, type FallFoliageStyleJson, parseFallFoliageStyle } from '../utils/fallFoliageLayers';

const apiKey = process.env.NEXT_PUBLIC_API_KEY!;

/**
 * Fetched with a bare `fetch` rather than `@alltrails/core/utils/get`: `/wmts/*` 302-redirects to a
 * signed CloudFront host that rejects our default API headers, so the redirected request 400s.
 */
export async function getFallFoliageStyle(publicBaseUrl: string, isFreeOverlay?: boolean): Promise<FallFoliageStyle> {
  const response = await fetch(
    `${publicBaseUrl}/wmts/${isFreeOverlay ? 'featured' : 'overlay'}/style/${isFreeOverlay ? 'fall-foliage-featured' : 'fall-foliage'}?key=${apiKey}`
  );
  if (!response.ok) {
    throw new Error(`Failed to fetch fall foliage styles: ${response.status}`);
  }

  const styleJson: FallFoliageStyleJson = await response.json();
  return parseFallFoliageStyle(styleJson, apiKey);
}
